import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Drawer } from '@ahmdigital/ui';
import { PRODUCT_LIMIT_CATEGORY } from '@ahmdigital/constants';
import { useEffect, useState } from 'react';

import { Customer } from '../../selectors/select-customer/types';
import { determineBundlesFromProductId } from '../../pages/choosable/pages/picker/utils/bundle';
import { DRAWER_IDS } from '../../ahm-constants/ui';
import { Price } from '../../models/price';
import { ProductWithServicesType } from '../../types/product';
import AmbulanceSection from '../../pages/choosable/pages/picker/components/ambulance-section';
import BaseBundleSection from '../../pages/choosable/pages/picker/components/base-bundle-section';
import BundlesSection from '../../pages/choosable/pages/picker/components/bundles-section';
import DrawerActions from '../../actions/drawer';
import Footer from './components/footer';
import getChoosableAllIncludedServices from '../../pages/choosable/pages/picker/utils/get-choosable-all-included-services';
import selectChoosableComparerProductId from '../../selectors/select-choosable-comparer-product-id';
import selectCurrentDrawer from '../../selectors/select-current-drawer';
import selectCustomer from '../../selectors/select-customer';
import selectEffectiveDateOverride from '../../selectors/select-effective-date-override';
import selectIsPremiumChangeEnabled from '../../selectors/select-is-premium-change-enabled';
import selectProducts from '../../selectors/select-products';
import SnakeSeparator from '../../pages/choosable/pages/picker/components/snake-separator';
import type { RootState } from '../../reducers';

type PickerDrawerProps = {
  actions: {
    drawer: {
      closeDrawer: () => void;
    };
  };
  choosableComparerProductId?: string;
  customer: Customer;
  drawer?: string;
  effectiveDate?: string;
  prices?: Record<string, Price>;
  products?: Record<string, ProductWithServicesType>;
};

const PickerDrawer = ({
  actions,
  choosableComparerProductId,
  customer,
  drawer,
  effectiveDate,
  prices,
  products = undefined,
}: PickerDrawerProps) => {
  const [selectedBundles, setSelectedBundles] = useState([]);
  const isOpen = drawer === DRAWER_IDS.PICKER;
  const allIncludedServices = getChoosableAllIncludedServices(products);
  const teethBundleServices = allIncludedServices.find((bundle) => bundle.limitId === PRODUCT_LIMIT_CATEGORY.TEETH);

  useEffect(() => {
    // @ts-expect-error - Automatic, Please fix when editing this file
    setSelectedBundles(determineBundlesFromProductId(choosableComparerProductId));
  }, [choosableComparerProductId]);

  return (
    <Drawer
      footer={
        <Footer customer={customer} effectiveDate={effectiveDate} prices={prices} selectedBundles={selectedBundles} />
      }
      isFullWidthMobile
      isOpen={isOpen}
      isWide
      location="right"
      shouldReturnFocusAfterClose={false}
      title="Choosable extras"
      toggleMenu={actions.drawer.closeDrawer}
    >
      <BaseBundleSection {...{ includedServices: teethBundleServices, isBundleChosen: true, scale: customer.scale }} />
      <AmbulanceSection isStacked />
      <SnakeSeparator />
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <BundlesSection
        {...{
          allIncludedServices,
          isCondensed: true,
          scale: customer.scale,
          selectedBundles,
          setSelectedBundles,
        }}
      />
    </Drawer>
  );
};

const mapStateToProps = (state: RootState) => ({
  choosableComparerProductId: selectChoosableComparerProductId(state),
  customer: selectCustomer(state),
  drawer: selectCurrentDrawer(state),
  effectiveDate: selectEffectiveDateOverride(state),
  isPremiumChangeEnabled: selectIsPremiumChangeEnabled(state),
  prices: state.price.data,
  products: selectProducts(state),
  useFutureEffectiveDate: state.price.useFutureEffectiveDate,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: {
    drawer: bindActionCreators(DrawerActions, dispatch),
  },
});

// @ts-expect-error - Automatic, Please fix when editing this file
export default connect(mapStateToProps, mapDispatchToProps)(PickerDrawer);
